export const RECENTLY_VIEWED_CONTAINER_ID = 'recentlyViewed';
export const INCREMENT_VIEWED_PRODUCTS = 'recentlyViewed::ProductsSwitch::Increment';
export const HAS_VIEWED_PRODUCTS = 'recentlyViewed::hasProduct';
